import React from 'react';

import PropTypes from 'prop-types';

import { Text, TextTypePropType } from 'ui-components/components/text';

import messages from './messages';

const OrderNumber = ({ orderNumber, className, textType }) => {
  return <Text className={className} formattedMessageValues={{ orderNumber }} textType={textType} value={messages.orderNumber} />;
};

export default OrderNumber;

OrderNumber.propTypes = {
  orderNumber: PropTypes.string,
  className: PropTypes.string,
  textType: TextTypePropType.isRequired,
};
